import React from "react";
import { Header } from "../Components/Header";
import { WelcomeHeader } from "../Components/welcomeHeader";
import { Providers } from "../Components/Providers";
import { Features } from "../Components/Features";
import { GetStarted } from "../Components/GetStarted";
import { Plans } from "../Components/Plans";
import { PrimaryPlans } from "../Components/PrimaryPlans";
import { Organizations } from "../Components/Organizations";
import { Capabilities } from "../Components/Capabilities";
import { AboutUs } from "../Components/About";
import { Contacts } from "../Components/Contact";
import { Footer } from "../Components/Footer";

// Audience order: providers first (they bring members and organisations), members second, organisations third.
export const HomePage = () => {
  return (
    <div className="main-wrapper">
      <Header />
      <WelcomeHeader />
      <Providers />
      <Features />
      <GetStarted />
      <Plans />
      <PrimaryPlans />
      <Organizations />
      <Capabilities />
      <AboutUs />
      <Contacts />
      <Footer />
    </div>
  );
};
